<template>
  <div class="d-flex">
    <v-divider class="ml-1" vertical />
    <v-data-table
      :items="branch.payments"
      :headers="headers"
      hide-default-footer
      disable-pagination
      class="grey lighten-4 flex-grow-1 rounded-0"
    >
      <template v-slot:[`item.code`]="{ item }">
        <span class="body-2 mb-0">
          {{ `#${item.code}` }}
        </span>
      </template>
      <template v-slot:[`item.transaction_id`]="{ item }">
        <v-chip class="body-2">
          <small>{{ item.id }}</small>
          <CopyToClipboard :value="item.id" />
        </v-chip>
      </template>
      <template v-slot:[`item.date`]="{ item }">
        <span class="body-2">
          {{ formatDate(item.date) }}
        </span>
      </template>
      <template v-slot:[`item.value`]="{ item }">
        <span class="body-2">
          {{ formatMoney(item.value) }}
        </span>
      </template>
    </v-data-table>
    <v-divider vertical />
  </div>
</template>

<script>
import CopyToClipboard from '@/components/app/CopyToClipboard'

import { catalogDate, catalogMonetary } from '@/util/catalog'
import { invoiceHeader } from '@/views/listHeaders/paymentListHeaders'

export default {
  name: 'HausefulInvoiceTable',

  props: {
    branch: {
      type: Object,
      required: true,
    },
  },

  components: {
    CopyToClipboard,
  },

  methods: {
    formatDate(date) {
      return catalogDate(date)
    },

    formatMoney(amount) {
      return catalogMonetary(amount)
    },
  },

  data() {
    return {
      headers: invoiceHeader,
    }
  }
}
</script>
